import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { LayoutStandardCrud } from '@/components';
import TitleFilter from '../component/title-filter';
import './index.less';
import { DatePicker, message, Button, Icon } from 'antd';
import moment from 'moment';
import { defaultAxios } from '@/utils';
import _ from 'lodash';
import { TableLv2 } from '../../../../components/common/table/level2';

const RangePicker = DatePicker.RangePicker;
const NewTraining: React.FC = () => {
    const [newTrainingData, setNewTrainingData] = useState<any>([]);
    const [newTrainingLoading, setNewTrainingLoading] = useState(false);
    const [acMenuSelect, setACMenuSelect] = useState<string>('');
    const afterDay = moment().subtract(1, 'week');
    const [taskEndTime, setTaskEndTime] = useState({
        start: afterDay.startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        end: afterDay.endOf('month').format('YYYY-MM-DD HH:mm:ss'),
    });
    useEffect(() => {
        if (acMenuSelect) {
            fetchNewTrainingData();
        }
    }, [acMenuSelect]);
    const tableColumns: any = [
        {
            title: '有效任务总数',
            dataIndex: 'train_task_valid_num',
            width: '100px',
        },
        {
            title: '按时完成数',
            dataIndex: 'train_task_finish_num',
            width: '100px',
        },
        {
            title: '按时完成率',
            dataIndex: 'train_task_finish_rate',
            width: '100px',
            render: (v: any) => `${v}%`,
        },
        {
            title: '逾期完成数',
            width: '100px',
            dataIndex: 'train_task_overdue_finish_num',
        },
        {
            title: '逾期完成率',
            width: '100px',
            dataIndex: 'train_task_overdue_finish_rate',
            render: (v: any) => `${v}%`,
        },
        {
            title: '扔回公海异常关闭任务数',
            width: '100px',
            dataIndex: 'train_task_close_num',
        },
        {
            title: '逾期未完成数',
            width: '100px',
            dataIndex: 'train_task_overdue_unfinish_num',
        },
        {
            width: '100px',
            title: '已取消任务数',
            dataIndex: 'train_task_cancel_num',
        },
    ];
    if (acMenuSelect) {
        switch (acMenuSelect) {
            case 'country':
                // tableColumns.unshift({
                //     title: '目标等级',
                //     dataIndex: 'level',
                // });
                break;
            case 'personal':
                tableColumns.unshift({
                    title: '销售',
                    dataIndex: 'sale_name',
                    fixed: true,
                });
            case 'group':
                tableColumns.unshift({
                    title: '小组',
                    dataIndex: 'sale_dept_name',
                    fixed: true,
                });
            case 'city':
                tableColumns.unshift({
                    title: '城市',
                    dataIndex: 'sale_city_name',
                    fixed: true,
                });
            case 'area':
                tableColumns.unshift({
                    title: '区域',
                    dataIndex: 'sale_area_name',
                    fixed: true,
                });
            default:
                break;
        }
    }
    const fetchNewTrainingData = async () => {
        if (!acMenuSelect) {
            // 若无，则代表没权限或权限未加载
            return;
        }
        const url = '/crm/data/query/list_sale_task_statistical_model';
        setNewTrainingLoading(true);
        const needFiledKey = _.map(tableColumns, item => {
            return item.dataIndex;
        });
        const [d, e] = await defaultAxios.put(url, {
            begin_time: moment(taskEndTime.start).format('YYYY-MM-DD'),
            end_time: moment(taskEndTime.end).format('YYYY-MM-DD'),
            fields: needFiledKey,
        });
        setNewTrainingLoading(false);
        if (d === null || d.data === null) {
            message.error('查询失败～');
            setNewTrainingData([]);
            return [null, e];
        }
        const data = d.data;
        if (data && Array.isArray(data)) {
            setNewTrainingData(data);
        } else {
            setNewTrainingData([]);
            message.error(data?.msg || '查询失败～');
        }
    };
    const exportNewTrainingData = () => {
        const url = `/bff/api/rest/ana/sales/new-training?begin_time=${moment(
            taskEndTime.start,
        ).format('YYYY-MM-DD')}&end_time=${moment(taskEndTime.end).format(
            'YYYY-MM-DD',
        )}&exportType=${acMenuSelect}`;
        window.open(url, '_blank');
    };
    const onActionSearchTimeChange = (
        dates: any,
        dateStrings: [string, string],
    ) => {
        // const limitStart = moment(dateStrings[1])
        //     .subtract('3', 'months')
        //     .startOf('days');
        // const startMoment = moment(dateStrings[0]).startOf('days');
        // if (limitStart.isAfter(startMoment)) {
        //     message.warning('请选择小于或等于三个月的时间区间～');
        //     return;
        // }
        setTaskEndTime({
            start: dateStrings[0],
            end: dateStrings[1],
        });
        // reload();
    };
    const renderFilter = () => {
        return (
            <>
                <div
                    className="ana-filter-item"
                    style={{
                        marginRight: '8px',
                        display: 'inline-block',
                    }}
                >
                    <label htmlFor="time">任务截止日期：</label>
                    <RangePicker
                        name="time"
                        disabled={newTrainingLoading}
                        value={[
                            moment(taskEndTime.start),
                            moment(taskEndTime.end),
                        ]}
                        showTime={true}
                        format="YYYY-MM-DD HH:mm:ss"
                        onChange={onActionSearchTimeChange}
                        style={{ width: '400px' }}
                        allowClear={false}
                        onOk={() => {
                            fetchNewTrainingData();
                        }}
                    />
                </div>
                <Button
                    type="primary"
                    disabled={newTrainingLoading}
                    onClick={() => {
                        exportNewTrainingData();
                    }}
                    style={{
                        display: 'inline-block',
                    }}
                >
                    导出
                </Button>
                <a
                    style={{
                        fontSize: '14px',
                        marginLeft: '12px',
                        fontWeight: 500,
                    }}
                    target="_blank"
                    href="https://maimai.feishu.cn/wiki/wikcnlkHh26FaSnTTRiKc1386If"
                >
                    <Icon
                        style={{
                            marginRight: '2px',
                        }}
                        type="question-circle"
                    />
                    口径说明
                </a>
            </>
        );
    };
    return (
        <LayoutStandardCrud
            title={
                <TitleFilter
                    pageKey={'new-training'}
                    onFilter={filterData => {
                        if (filterData) {
                            setACMenuSelect(filterData?.menu);
                        }
                    }}
                />
            }
            message={null}
            popups={null}
            multipleOps={null}
            globalOps={null}
            filters={renderFilter()}
            dataTable={
                <TableLv2
                    dataSource={newTrainingData}
                    loading={newTrainingLoading}
                    closeRowSelection={true}
                    pagination={false}
                    scroll={{ x: '100%' }}
                    columns={tableColumns}
                />
            }
        />
    );
};

export default observer(NewTraining);
